"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentDateInTimestamp = void 0;
const getCurrentDateInTimestamp = () => {
    const currentDate = new Date().getTime() / 1000;
    return Number(currentDate.toString().split('.')[0]);
};
exports.getCurrentDateInTimestamp = getCurrentDateInTimestamp;
